
import React from 'react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const CookiePolicy = () => {
    return (
        <div className="bg-white pt-32 pb-20 px-4 sm:px-6 lg:px-8">
            <SEO title="Cookie Policy | BPO Consultants" description="How we use cookies to improve your experience." />
            <FadeIn className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-[#20222D] mb-8">Cookie Policy</h1>
                <div className="prose prose-lg text-gray-600">
                    <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
                    <p className="mb-6">This Cookie Policy explains what cookies are, how we use them, and your choices regarding cookies.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">1. What Are Cookies?</h2>
                    <p className="mb-4">Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">2. How We Use Cookies</h2>
                    <p className="mb-4">We use cookies to understand how you use our website, to analyze traffic, and to personalize content. We may also use third-party cookies for analytics purposes.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">3. Your Choices</h2>
                    <p className="mb-4">You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.</p>
                </div>
            </FadeIn>
        </div>
    );
};

export default CookiePolicy;
